module.exports = __webpack_public_path__ + "img/circle-half-stroke.37521f56.svg";